module.exports = __webpack_public_path__ + "img/David-Tate.98b20485.jpeg";